;(function () {
	window.__lPlanRevealActive = true

	let planRevealObserver = null

	if (!customElements.get('l-plan-carousel')) {
		class LTAPlanCarousel extends HTMLElement {
			connectedCallback() {
				this.viewport = this.querySelector('[data-plan-carousel-viewport]')
				this.fill = this.querySelector('[data-plan-carousel-fill]')
				this.prevBtn = this.querySelector('[data-plan-carousel-prev]')
				this.nextBtn = this.querySelector('[data-plan-carousel-next]')
				if (!this.viewport) return

				this._onScroll = this._update.bind(this)
				this._onPrev = this._scrollByPage.bind(this, -1)
				this._onNext = this._scrollByPage.bind(this, 1)
				this._onPointerDown = this._handlePointerDown.bind(this)
				this._onPointerMove = this._handlePointerMove.bind(this)
				this._onPointerUp = this._handlePointerUp.bind(this)
				this._onImageLoad = this._update.bind(this)
				this._onDragStart = this._handleDragStart.bind(this)
				this._scrollTween = null
				this._scrollAnimationFrame = null
				this._dragMoved = false

				this.viewport.addEventListener('scroll', this._onScroll, { passive: true })
				this.viewport.addEventListener('pointerdown', this._onPointerDown)
				this.viewport.addEventListener('pointermove', this._onPointerMove)
				this.viewport.addEventListener('pointerup', this._onPointerUp)
				this.viewport.addEventListener('pointercancel', this._onPointerUp)
				this.viewport.addEventListener('dragstart', this._onDragStart)
				window.addEventListener('resize', this._onScroll)
				if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev)
				if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext)

				this.querySelectorAll('img').forEach(
					function (img) {
						if (!img.complete) img.addEventListener('load', this._onImageLoad, { once: true })
					}.bind(this)
				)

				window.requestAnimationFrame(this._onScroll)
			}

			disconnectedCallback() {
				this._killScrollTween()
				if (this.viewport) this.viewport.removeEventListener('scroll', this._onScroll)
				if (this.viewport) this.viewport.removeEventListener('pointerdown', this._onPointerDown)
				if (this.viewport) this.viewport.removeEventListener('pointermove', this._onPointerMove)
				if (this.viewport) this.viewport.removeEventListener('pointerup', this._onPointerUp)
				if (this.viewport) this.viewport.removeEventListener('pointercancel', this._onPointerUp)
				if (this.viewport) this.viewport.removeEventListener('dragstart', this._onDragStart)
				window.removeEventListener('resize', this._onScroll)
				if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev)
				if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext)
				this.querySelectorAll('img').forEach(
					function (img) {
						img.removeEventListener('load', this._onImageLoad)
					}.bind(this)
				)
			}

			_scrollByPage(dir) {
				if (!this.viewport) return

				const step = Math.max(1, this.viewport.clientWidth)
				const next = this._clampScroll(Math.round((this.viewport.scrollLeft + dir * step) / step) * step)
				const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

				// Prefer native (GPU-smooth) scrolling; fall back to the manual tween on browsers
				// without smooth-scroll support. Snap is re-enabled so the browser settles for us.
				if ('scrollBehavior' in document.documentElement.style) {
					this._killScrollTween()
					this.viewport.scrollTo({ left: next, behavior: reduceMotion ? 'auto' : 'smooth' })

					return
				}

				this._animateToScroll(next, reduceMotion ? 0 : 0.58)
			}

			_handlePointerDown(event) {
				if (!this.viewport || (event.button !== undefined && event.button !== 0)) return
				if (event.target && event.target.closest && event.target.closest('button, a, input, textarea, select, label'))
					return

				this._killScrollTween()
				this._isDragging = true
				this._dragMoved = false
				this._dragStartX = event.clientX
				this._dragStartScrollLeft = this.viewport.scrollLeft
				this.viewport.classList.add('is-dragging')
				this._setSnapDisabled(true)
				if (this.viewport.setPointerCapture) this.viewport.setPointerCapture(event.pointerId)
			}

			_handlePointerMove(event) {
				if (!this._isDragging || !this.viewport) return

				const delta = event.clientX - this._dragStartX
				if (Math.abs(delta) > 3) {
					this._dragMoved = true
					event.preventDefault()
				}
				this.viewport.scrollLeft = this._clampScroll(this._dragStartScrollLeft - delta)
				this._update()
			}

			_handlePointerUp(event) {
				if (!this._isDragging || !this.viewport) return

				const shouldSettle = this._dragMoved
				const target = shouldSettle ? this._getSnapTarget() : null
				this._isDragging = false
				if (shouldSettle) this.viewport.classList.add('is-settling')
				if (
					this.viewport.releasePointerCapture &&
					this.viewport.hasPointerCapture &&
					this.viewport.hasPointerCapture(event.pointerId)
				) {
					this.viewport.releasePointerCapture(event.pointerId)
				}
				this.viewport.classList.remove('is-dragging')

				if (shouldSettle) {
					this._settleAfterDrag(target)

					return
				}

				this._setSnapDisabled(false)
				this._update()
			}

			_handleDragStart(event) {
				event.preventDefault()
			}

			_getMaxScroll() {
				return this.viewport ? Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth) : 0
			}

			_clampScroll(value) {
				return Math.min(this._getMaxScroll(), Math.max(0, value))
			}

			_getSnapTarget() {
				if (!this.viewport) return 0

				const step = Math.max(1, this.viewport.clientWidth)

				return this._clampScroll(Math.round(this.viewport.scrollLeft / step) * step)
			}

			_settleAfterDrag(target) {
				this._animateToScroll(target, 0.64)
			}

			_killScrollTween() {
				if (this._scrollTween && this._scrollTween.kill) {
					this._scrollTween.kill()
				}
				if (this._scrollAnimationFrame) {
					window.cancelAnimationFrame(this._scrollAnimationFrame)
				}

				this._scrollTween = null
				this._scrollAnimationFrame = null
				if (this.viewport) {
					this.viewport.classList.remove('is-settling')
					this._setSnapDisabled(false)
				}
			}

			_setSnapDisabled(isDisabled) {
				if (!this.viewport) return

				this.viewport.style.scrollSnapType = isDisabled ? 'none' : ''
			}

			_animateToScroll(target, duration) {
				const viewport = this.viewport
				if (!viewport) return

				const start = viewport.scrollLeft
				const end = this._clampScroll(target)
				const distance = end - start

				this._killScrollTween()
				viewport.classList.add('is-settling')
				this._setSnapDisabled(true)

				if (Math.abs(distance) < 1) {
					viewport.scrollLeft = end
					viewport.classList.remove('is-settling')
					this._setSnapDisabled(false)
					this._update()

					return
				}

				const startedAt = window.performance.now()
				const durationMs = Math.max(1, duration * 1000)
				const easeOut = function (progress) {
					return 1 - Math.pow(1 - progress, 3)
				}
				const finish = () => {
					viewport.scrollLeft = end
					viewport.classList.remove('is-settling')
					this._scrollAnimationFrame = null
					this._setSnapDisabled(false)
					this._update()
				}
				const tick = (now) => {
					const progress = Math.min(1, (now - startedAt) / durationMs)
					viewport.scrollLeft = start + distance * easeOut(progress)
					this._update()

					if (progress >= 1) {
						finish()

						return
					}

					this._scrollAnimationFrame = window.requestAnimationFrame(tick)
				}

				this._scrollAnimationFrame = window.requestAnimationFrame(tick)
			}

			_setDisabled(btn, isDisabled) {
				if (!btn) return

				btn.classList.toggle('is-disabled', isDisabled)
				btn.disabled = isDisabled
				btn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false')
			}

			_update() {
				const viewport = this.viewport
				if (!viewport) return

				const max = viewport.scrollWidth - viewport.clientWidth
				const progress = max > 0 ? Math.min(1, (viewport.scrollLeft + viewport.clientWidth) / viewport.scrollWidth) : 1

				if (this.fill) this.fill.style.setProperty('--l-plan-carousel-progress', progress)
				this._setDisabled(this.prevBtn, viewport.scrollLeft <= 1)
				this._setDisabled(this.nextBtn, viewport.scrollLeft >= max - 1)
			}
		}

		customElements.define('l-plan-carousel', LTAPlanCarousel)
	}

	function initPlanReveals(root) {
		const els = getRevealTargets(root, ':not(.is-revealed)')
		const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

		if (!els.length) {
			if (!document.querySelector('[data-l-plan-reveal]:not(.is-revealed)')) {
				document.documentElement.classList.remove('l-plan-reveal-prep')
			}

			return
		}

		if (prefersReducedMotion || !window.gsap || !window.IntersectionObserver) {
			revealPlanStatic(root)

			return
		}

		if (planRevealObserver) planRevealObserver.disconnect()

		planRevealObserver = new IntersectionObserver(handlePlanRevealEntries, {
			root: null,
			rootMargin: '0px 0px -16% 0px',
			threshold: 0.01,
		})

		els.forEach(function (el) {
			el.classList.add('is-reveal-bound')
			planRevealObserver.observe(el)
		})
	}

	function getRevealScope(root) {
		if (root && root.querySelectorAll) return root

		return document
	}

	function getRevealTargets(root, suffix) {
		const scope = getRevealScope(root)
		const selector = '[data-l-plan-reveal]' + (suffix || '')
		const els = Array.from(scope.querySelectorAll(selector))

		if (scope.matches && scope.matches(selector)) {
			els.unshift(scope)
		}

		return els
	}

	function handlePlanRevealEntries(entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return

			planRevealObserver.unobserve(entry.target)
			try {
				playPlanReveal(entry.target)
			} catch (error) {
				markPlanRevealComplete(entry.target)
			}
		})
	}

	function playPlanReveal(el) {
		if (el.classList.contains('is-revealed') || el.classList.contains('is-revealing')) return

		const config = getPlanRevealConfig(el)
		const parts = getPlanRevealParts(el)
		const media = getPlanRevealMedia(el)
		const animatedTargets = [el].concat(parts, media)
		const tl = window.gsap.timeline({
			defaults: {
				ease: 'power3.out',
				overwrite: 'auto',
			},
			onComplete: function () {
				markPlanRevealComplete(el)
				window.gsap.set(animatedTargets.length ? animatedTargets : el, {
					clearProps: 'opacity,visibility,transform,willChange',
				})
			},
		})

		el.classList.add('is-revealing')
		window.gsap.set(animatedTargets.length ? animatedTargets : el, { willChange: 'transform,opacity' })

		tl.fromTo(el, getPlanRevealFrom(config.shell), getPlanRevealTo(config.shell), 0)

		if (parts.length) {
			tl.fromTo(parts, getPlanRevealFrom(config.parts), getPlanRevealTo(config.parts), 0.08)
		}

		if (media.length) {
			tl.fromTo(media, getPlanRevealFrom(config.media), getPlanRevealTo(config.media), config.mediaAt)
		}
	}

	function markPlanRevealComplete(el) {
		el.classList.remove('is-reveal-bound')
		el.classList.remove('is-revealing')
		el.classList.add('is-revealed')

		if (!document.querySelector('[data-l-plan-reveal]:not(.is-revealed)')) {
			document.documentElement.classList.remove('l-plan-reveal-prep')
		}
	}

	function revealPlanStatic(root) {
		document.documentElement.classList.remove('l-plan-reveal-prep')
		getRevealTargets(root).forEach(function (el) {
			markPlanRevealComplete(el)
		})
	}

	function getPlanRevealFrom(vars) {
		const from = {}

		copyPlanRevealProp(vars, from, 'scale')
		copyPlanRevealProp(vars, from, 'transformOrigin')
		copyPlanRevealProp(vars, from, 'x')
		copyPlanRevealProp(vars, from, 'y')

		if (vars.opacity !== undefined) from.autoAlpha = vars.opacity

		return from
	}

	function getPlanRevealTo(vars) {
		const to = {}

		copyPlanRevealProp(vars, to, 'duration')
		copyPlanRevealProp(vars, to, 'ease')
		copyPlanRevealProp(vars, to, 'stagger')
		copyPlanRevealProp(vars, to, 'transformOrigin')

		if (vars.opacity !== undefined) to.autoAlpha = 1
		if (vars.scale !== undefined) to.scale = 1
		if (vars.x !== undefined) to.x = 0
		if (vars.y !== undefined) to.y = 0

		return to
	}

	function copyPlanRevealProp(source, target, prop) {
		if (source[prop] !== undefined) {
			target[prop] = source[prop]
		}
	}

	function getPlanRevealConfig(el) {
		const config = {
			shell: {
				opacity: 0,
				y: 16,
				duration: 0.65,
				ease: 'power2.out',
			},
			parts: {
				opacity: 0,
				y: 18,
				scale: 0.99,
				duration: 0.74,
				stagger: { each: 0.05, from: 'start' },
			},
			media: {
				scale: 1.025,
				duration: 1,
				ease: 'power2.out',
				transformOrigin: '50% 55%',
			},
			mediaAt: 0.06,
		}

		if (el.classList.contains('l-plan-hero__inner')) {
			config.shell = {
				opacity: 0,
				scale: 0.985,
				duration: 0.75,
				ease: 'power2.out',
			}
			config.parts = {
				opacity: 0,
				y: -10,
				scale: 0.985,
				duration: 0.85,
				stagger: 0.06,
				transformOrigin: '50% 50%',
			}
			config.media.scale = 1.04
			config.media.duration = 1.2
		} else if (el.classList.contains('l-plan-contact__inner')) {
			config.parts = {
				opacity: 0,
				x: function (index, node) {
					return node.classList.contains('l-plan-contact__media') ? 14 : 0
				},
				y: function (index, node) {
					return node.classList.contains('l-plan-field') ? 10 : 0
				},
				scale: 0.99,
				duration: 0.74,
				stagger: { each: 0.045, from: 'start' },
			}
		}

		return config
	}

	function getPlanRevealParts(el) {
		let selector

		if (el.classList.contains('l-plan-hero__inner')) {
			selector = '.l-plan-hero__title'
		} else if (el.classList.contains('l-plan-intro__inner')) {
			selector = '.l-plan-intro__body, .l-plan-intro__note, .l-plan-intro__action'
		} else if (el.classList.contains('l-plan-venues__inner')) {
			selector = '.l-plan-venues__heading, .l-plan-venues__body, .l-plan-venue, .l-plan-venues__controls'
		} else if (el.classList.contains('l-plan-exp__inner')) {
			selector = '.l-plan-exp__heading, .l-plan-exp__card, .l-plan-exp__controls'
		} else if (el.classList.contains('l-plan-contact__inner')) {
			selector = '.l-plan-contact__heading, .l-plan-field, .l-plan-contact__submit, .l-plan-contact__media'
		} else if (el.classList.contains('l-plan-reservation__inner')) {
			selector =
				'.l-plan-reservation__logo, .l-plan-reservation__heading, .l-plan-reservation__address, .l-plan-reservation__brand'
		}

		return selector ? getVisibleNodes(el.querySelectorAll(selector)) : []
	}

	function getPlanRevealMedia(el) {
		return getVisibleNodes(
			el.querySelectorAll(
				'.l-plan-hero__img, .l-plan-hero__video video, .l-plan-venue__img, .l-plan-exp__img, .l-plan-exp__video video, .l-plan-contact__img'
			)
		)
	}

	function getVisibleNodes(nodes) {
		const seen = []

		return Array.prototype.filter.call(nodes, function (node) {
			if (!node || seen.indexOf(node) !== -1 || !node.getClientRects().length) return false
			seen.push(node)

			return true
		})
	}

	function initPlanPage(root) {
		initPlanReveals(root)
	}

	function safeInitPlanPage(root) {
		try {
			initPlanPage(root)
		} catch (error) {
			revealPlanStatic(root)
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			safeInitPlanPage(document)
		})
	} else {
		safeInitPlanPage(document)
	}

	if (window.Shopify && window.Shopify.designMode) {
		document.addEventListener('shopify:section:load', function (event) {
			safeInitPlanPage(event.target)
		})
	}
})()
